import { makeCanvasByImg } from '../../S/util.js';
import { CanvasS } from '../../S/Function/module/CanvasS.js';

export function invertImage(img) {
  return new Promise((resolve, reject) => {
    const width = img.width;
    const height = img.height;

    if (!width || !height) {
      reject(new Error('Invalid image dimensions'));
      return;
    }

    // OffscreenCanvas 지원 여부 확인
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(img, 0, 0, width, height);
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0) {
        // 투명도가 0이 아닐 때만 반전
        data[i] = 255 - data[i]; // R
        data[i + 1] = 255 - data[i + 1]; // G
        data[i + 2] = 255 - data[i + 2]; // B
      }
    }

    ctx.putImageData(imageData, 0, 0);

    const invertedImg = new Image();
    invertedImg.onload = () => resolve(invertedImg);
    invertedImg.onerror = reject;
    invertedImg.src = canvas.toDataURL();
  });
}

export function fileToImg(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = () => reject(new Error('Image load fail'));
      img.src = event.target.result;
    };
    reader.onerror = () => reject(new Error('Image read fail'));
    reader.readAsDataURL(file);
  });
}

export const isEmptyPngFile = async (file) => {
  const canvas = await makeCanvasByImg(await fileToImg(file));
  return CanvasS.isEmptyCanvas(canvas);
};
